export default __webpack_public_path__ + "static/media/ChallPacoOpenly@2x.1baa3b60.png";